import React from 'react';
import { aboutContent } from '../../content/about-content';

/**
 * Hero Section Component
 *
 * Full-width gradient banner introducing the About page.
 */
const HeroSection = React.forwardRef(({ id = 'hero' }, ref) => {
  const { hero } = aboutContent;

  return (
    <section id={id} ref={ref} className="about-hero">
      <div className="about-hero__content">
        <p className="about-hero__tagline">Neuropedagogy Framework</p>
        <h1 className="about-hero__title">{hero.title}</h1>
        <p className="about-hero__subtitle">{hero.tagline}</p>
      </div>

      {/* Decorative brain icon */}
      <svg
        className="about-hero__brain-icon"
        viewBox="0 0 100 100"
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M50,10 Q70,10 80,25 Q90,40 85,55 Q90,70 80,80 Q70,90 50,90 Q30,90 20,80 Q10,70 15,55 Q10,40 20,25 Q30,10 50,10 Z" opacity="0.3" />
        <circle cx="35" cy="40" r="8" opacity="0.2" />
        <circle cx="65" cy="40" r="8" opacity="0.2" />
        <circle cx="50" cy="60" r="10" opacity="0.2" />
        <path d="M30,50 Q40,45 50,50 Q60,45 70,50" stroke="currentColor" strokeWidth="2" fill="none" opacity="0.2" />
      </svg>
    </section>
  );
});

HeroSection.displayName = 'HeroSection';

export default HeroSection;
